import { FC } from "react";
import { useTranslation } from "react-i18next";

import {
  StatusIndicatorNotificationMap,
  StatusIndicatorStyled,
} from "@ryde/controls";
import { NotificationPriorityEnum } from "@ryde/shared";

import { NotificationItemHeaderStyled } from "./notification-item-header.styled";

interface INotificationItemHeaderProps {
  priority: NotificationPriorityEnum;
  title: string;
  time: number;
}

export const NotificationItemHeader: FC<INotificationItemHeaderProps> = ({
  priority,
  title,
  time,
}) => {
  const { t } = useTranslation();
  const statusStyles = StatusIndicatorNotificationMap[priority];
  return (
    <NotificationItemHeaderStyled>
      <StatusIndicatorStyled
        $bgColor={statusStyles.$bgColor}
        $borderColor={statusStyles.$borderColor}
        $color={statusStyles.$color}
      >
        {t(`notification.formLabel.${priority}`)}
      </StatusIndicatorStyled>
      <h5 className="NotificationItemHeader-Title">
        {t(`notification.formLabel.${title}`)}
      </h5>
      <span className="NotificationItemHeader-Time">{time}h</span>
    </NotificationItemHeaderStyled>
  );
};
